module.exports = __webpack_public_path__ + "europa-50-paper.jpg?30bf70d72fc977be9bfca359d9a12f6c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/europa-50-paper.jpg
// module id = 363
// module chunks = 0